import { createComponent } from '@mtfe/sweet';
import { common, dom } from '@mtfe/sweet-utils';

import tpl from './dom.html';
import style from './style.less';

const ERROR_PAGE_MV = 'b_waimai_816ygvur_mv';

const { createUniqueId } = common;
const domId = createUniqueId();
const DEFAULT_TEXT = '页面送外卖去了-_-!';

const ErrorPage = (props = {}) => {
    const { oadLX, reportRefreshToLX, reportGotoH5ToLX, text } = props;

    const data = {
        domId,
        errorText: text || DEFAULT_TEXT,
    };
    const events = {
        refresh: () => {
            reportRefreshToLX && reportRefreshToLX();
            setTimeout(() => {
                window.location.reload();
            }, 100);
            return false;
        },
        gotoH5: () => {
            reportGotoH5ToLX && reportGotoH5ToLX();
            setTimeout(() => {
                window.location.href = 'https://h5.waimai.meituan.com/';
            }, 100);
            return false;
        },
    };
    const component = createComponent(tpl, { data, style }, events);

    oadLX && oadLX.mv(ERROR_PAGE_MV);
    return component;
};

export default ErrorPage;
